const RootDirectoryNames = {
    Root: 'root',
    StorageError: 'storage_error'
} as const;

export default RootDirectoryNames;
